<template>
    <div>
        <div class="title">
            <i class="material-icons success">check_circle</i>
            <span>已發佈授課服務</span>
        </div>
        
        <div class="dialog-second-content">
            <p>當有人詢問您的課程時，將會以 Email 通知，敬請密切注意</p>
        </div>

        <a href="/coursework" @click="confirm">我知道了</a>
    </div>
</template>
<script>
export default {
    name:"modalTest",
    props:{
        params:{
        }
    },
    data(){
        return{
            info:this.params.firstInput
        }
    },
    created(){
    },
    methods:{
        confirm(){
            this.$emit("close",this.info);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/teaching-counseling/PopModalTest.vue